export default function translate(i18n, propriete) {
  if (propriete.indexOf('AnneeCivile') !== -1) return i18n.t('addEditTypeTaxationTlpe.error.anneeCivile');
  if (propriete.indexOf('MontantAnnuel') !== -1) return i18n.t('addEditTypeTaxationTlpe.error.montantAnnuel');
  if (propriete.indexOf('MontantSemaine') !== -1) return i18n.t('addEditTypeTaxationTlpe.error.montantSemaine');
  return propriete;
}
